// src/store/useFeatureStore.js
import { create } from "zustand";

const useFeatureStore = create((set, get) => ({
  features: {},

  setFeatures: (features) => {
    set({ features });
  },

  isFeatureEnabled: (featureName) => {
    return get().features?.[featureName] || false;
  },

  clearFeatures: () => set({ features: {} }),
}));

export default useFeatureStore;
